import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-105" data-mp="1o3ncvzyfwkwu">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-amber/50 bg-mist p-9 text-center shadow-premium sm:p-12" data-id="element-106" data-mp="1o3dmwcdeadr5">
        <div className="text-5xl" aria-hidden="true" data-id="element-107" data-mp="1x4bsv07e8vcd">
          🛡️
        </div>
        <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-108" data-mp="1x28qrhsyvbra">
          Zero Risk. 7-Day Money-Back Guarantee.
        </h2>
        <p className="mt-6 text-sm leading-7 text-slate sm:text-base" data-id="element-109" data-mp="14gfmf3s0vp2e">
          Download all 6 volumes and all 5 bonus guides today. Open Volume 1 and review the 78 tarot
          cards. Work through the interpretation system. Apply the 200+ therapeutic questions with a
          practice client. Use the spreads. Print the reference charts. Apply the grounding
          protocols. Study the ethics guidelines. If within 7 days you don’t feel this is the most
          complete therapeutic tarot reference system you have ever owned — we will refund every
          single cent. No forms. No questions. No hassle. The risk is entirely ours.
        </p>
        <p className="mt-7 font-semibold text-sage" data-id="element-110" data-mp="tw9q12w2fy8g">✅ Real refund rate: less than 1%</p>
      </Reveal>
    </section>;
}